module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"new_lost":"New / Lost","top_backlinks":"Top Backlinks"},"fr":{"new_lost":"Nouveaux / Perdus","top_backlinks":"Top Backlinks"},"de":{"new_lost":"Neu / Verloren","top_backlinks":"Top-Backlinks"}}')
  delete Component.options._Ctor
}
